document.addEventListener("DOMContentLoaded", () => {

    const form = document.getElementById("buyback-form");
    const input = document.getElementById("buyback-upload");
    const preview = document.getElementById("buyback-preview");
    const dropzone = document.querySelector(".dropzone");
    const message = document.getElementById("buyback-message");

    if (!form || !input) return;

    function render(files) {

        preview.innerHTML = "";

        [...files].forEach(file => {

            if (file.size > 10 * 1024 * 1024) {
                alert(file.name + " dépasse 10 Mo.");
                return;
            }

            if (!file.type.startsWith("image/")) return;

            const reader = new FileReader();

            reader.onload = e => {

                const card = document.createElement("div");
                card.className = "preview-card";

                card.innerHTML = `
                    <img src="${e.target.result}">
                    <p>${file.name}</p>
                `;

                preview.appendChild(card);

            };

            reader.readAsDataURL(file);

        });

    }

    input.addEventListener("change", e => {
        render(e.target.files);
    });

    dropzone.addEventListener("dragover", e => {
        e.preventDefault();
        dropzone.classList.add("drag");
    });

    dropzone.addEventListener("dragleave", () => {
        dropzone.classList.remove("drag");
    });

    dropzone.addEventListener("drop", e => {

        e.preventDefault();

        dropzone.classList.remove("drag");

        input.files = e.dataTransfer.files;

        render(e.dataTransfer.files);

    });

    form.addEventListener("submit", async (e) => {

        e.preventDefault();

        message.innerHTML = "⏳ Envoi en cours...";

        const data = new FormData(form);

        [...input.files].forEach(file => {
            data.append("photos", file);
        });

        try {

            const response = await fetch(
                "https://trade-upload-api.route151.workers.dev",
                {
                    method: "POST",
                    body: data
                }
            );

            const result = await response.json();

            if (result.success) {

                message.innerHTML = "✅ Votre demande a bien été envoyée.";

                form.reset();

                preview.innerHTML = "";

            } else {

                message.innerHTML = "❌ " + (result.message || result.error || "Une erreur est survenue.");

            }

        } catch (err) {

            console.error(err);

            message.innerHTML = "❌ Une erreur est survenue.";

        }

    });

});